import { render, staticRenderFns } from "./selectRule.vue?vue&type=template&id=d98d7c50&"
import script from "./selectRule.vue?vue&type=script&lang=js&"
export * from "./selectRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports